import { createApi } from '@reduxjs/toolkit/query/react';
import { API_STATIC_SECRET } from '@http';
import { axiosBaseQuery } from './axiosBaseQuery';

/**
 * BNS-2890: App version check API
 * Checks web_version from apiStatic/app-config
 */

// Create a separate base query for app version with correct base URL
const appVersionBaseQuery = axiosBaseQuery({
  baseUrl: process.env.REACT_APP_BASE_API_URL || 'https://stg-api.siswamedia.com',
});

export const appVersionApi = createApi({
  reducerPath: 'appVersionApi',
  baseQuery: appVersionBaseQuery,
  endpoints: (builder) => ({
    getWebVersion: builder.query({
      query: () => ({
        url: '/v1/apiStatic/app-config',
        params: { key: 'web_version' },
        headers: {
          Authorization: API_STATIC_SECRET,
        },
      }),
      transformResponse: (response) => {
        // API returns: { status_code: 200, data: "0.0.1", ... }
        const version = response?.data;
        return typeof version === 'string' && version.length > 0 ? version : undefined;
      },
    }),
  }),
});

export const { useGetWebVersionQuery, useLazyGetWebVersionQuery } = appVersionApi;
